import { listSettings } from "@/api/admin";
import { useAsync } from "@/lib/useAsync";
import { Notice } from "@/components/ui/feedback";
import { SettingCard } from "@/components/SettingCard";
import { TestMailCard } from "@/components/TestMailCard";
import { PageHeader } from "@/components/ui/page-header";
import { Skeleton } from "@/components/ui/skeleton";

export function SettingsScreen() {
  const { data, loading, error, reload } = useAsync(() => listSettings(), []);

  return (
    <div className="space-y-4">
      <PageHeader title="Settings" description="Everything an operator can change without a deploy." />
      {error && <Notice tone="error">{error}</Notice>}

      {loading && !data ? (
        <div className="grid gap-4 lg:grid-cols-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-40" />
          ))}
        </div>
      ) : (
        <div className="grid gap-4 lg:grid-cols-2">
          {(data?.settings ?? []).map((setting) => (
            <SettingCard key={setting.key} setting={setting} onSaved={reload} />
          ))}
        </div>
      )}

      <div className="grid gap-4 lg:grid-cols-2">
        <TestMailCard />
      </div>
    </div>
  );
}
